<template lang='pug'>
    #Relatorios
        BaseHeader( titulo='Relatórios')

        .view-container-base-header
            el-tabs.card-relatorios(type='card')
                el-tab-pane(label='Camadas x Cliente')
                    CamadasEmpresa(
                        @buscar_empresas='buscarEmpresas',
                        :empresas='empresas'
                    )
                el-tab-pane(label='Laudos x Cliente')
                    LaudoEmpresa(
                        @buscar_empresas='buscarEmpresas',
                        :empresas='empresas'
                    )
                el-tab-pane.p-4(label='Usuários')
                    Usuarios(
                        @buscarEmpresas='buscarEmpresas',
                        @buscarUsuarios='buscarUsuarios',
                        @exportar_dados='exportarDadosUsuarios',
                        @reset='limparUsuarios',
                        :empresas='empresas',
                        :usuarios='usuarios',
                        :labels-grafico='dados_grafico_usuarios.labels',
                        :dados-grafico='dados_grafico_usuarios.data'
                    )
                        el-tab-pane.p-4(label='Usuários')
                el-tab-pane(label='Diagnósticos')
                    Diagnosticos(
                        @buscar_empresas='buscarEmpresas',
                        :empresas='empresas'
                    )
                el-tab-pane(label='Monitoramento Socioambiental')
                    MonitoramentoSocioambiental(
                        @buscar_empresas='buscarEmpresas',
                        :empresas='empresas'
                    )
                el-tab-pane(label='Monitoramento Agrícola')
                    Agricola(@buscar_empresas='buscarEmpresas', :empresas='empresas')
                el-tab-pane(label='Empresa x Protocolo')
                    ProtocoloEmpresa(@buscar_empresas='buscarEmpresas', :empresas='empresas')
</template>

<script>
import Usuarios from '@/views/admin/relatorios/Usuarios';
import MonitoramentoSocioambiental from '@/views/admin/relatorios/MonitoramentoSocioambiental';
import UsuarioService from '@/services/UsuarioService';
import Diagnosticos from '@/views/admin/relatorios/Diagnosticos';
import Agricola from '@/views/admin/relatorios/Agricola';
import CamadasEmpresa from '@/views/admin/relatorios/CamadasEmpresa';
import LaudoEmpresa from '@/views/admin/relatorios/LaudoEmpresa';
import ProtocoloEmpresa from '@/views/admin/relatorios/ProtocoloEmpresa';
import BaseHeader from '@/components/BaseHeader.vue';

export default {
    name: 'index',

    components: {
        BaseHeader,
        MonitoramentoSocioambiental,
        Usuarios,
        Diagnosticos,
        Agricola,
        CamadasEmpresa,
        LaudoEmpresa,
        ProtocoloEmpresa
    },

    data() {
        return {
            empresas: [],
            usuarios: [],
            dados_grafico_usuarios: {
                data: {},
                labels: []
            }
        };
    },

    created() {
        this.buscarEmpresas();
    },

    methods: {
        buscarEmpresas() {
            UsuarioService.getGroups(false)
                .then(({ data }) => {
                    this.empresas = data;
                })
                .catch(erro => {
                    this.$notify.error({
                        message: `Ocorreu um erro ao buscar as empresas - ${erro}`
                    });
                });
        },

        buscarUsuarios(filtros) {
            UsuarioService.getUsersByGroup(filtros).then(({ data }) => {
                this.usuarios.data = data.usuarios;
                this.usuarios.pageable = data.pageable;
                this.dadosGraficoUsuarios.data = data.totalUsuariosPorData;
                this.dadosGraficoUsuarios.labels = data.datasDisponiveis;
            });
        },

        exportarDadosUsuarios(filtros) {
            UsuarioService.exportUsersByGroup(filtros).then(() => {
                this.$notify.success({
                    message: 'Exportação realizada com sucesso!'
                });
            });
        },

        limparUsuarios() {
            this.usuarios = {
                data: [],
                pageable: {}
            };
        }
    }
};
</script>

<style lang='scss' scoped>
#Relatorios {
    height: 100%;
    width: 100%;
}

.card-relatorios {
    background: var(--white);
    height: 100%;
}
</style>
